// @flow
import React from 'react';
import environment from '../../../../../environment';
import { asyncPaymentRedirectToOrderPage, notFoundLibraryError } from '../../duck';
import {endpoints, postPaymentExecuteApi} from '../../api';
import analytics from '../../../../../analytics';

import type { Node } from 'react';
import type { Order } from '../../../../../entities';
import type { ImplementationType, PaymentImpl } from '../index';
import type {BillingAddressReq, PaymentExecuteReq} from '../../api';
import type { RootState } from '../../../../index';


export default class BitpayPayment implements PaymentImpl {
  type: ImplementationType = 'bitpay';
  order: Order;
  dispatch: Function;
  // Own impl attributes
  bitpayButtonId = 'bitPayButton';
  uiId: string = 'bitpayUI';

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    console.log('setup order', this.order);
    this.dispatch = dispatch;
    if (window) {
      if (!window.bitpay) {
        dispatch(notFoundLibraryError({
          code: 404,
          name: 'notFoundLibraryError',
          url: '',
        }));
        return;
      }

      window.handleClickBitPayButton = (e: any) => {
        if (this.order.invoice.payment && this.order.invoice.payment.paymentData &&
          this.order.invoice.payment.paymentData.id) {
          this.showPopUp(this.order.invoice.payment.paymentData.id);
        }
        return false;
      };
      const $bitPayButton = document.querySelector(`#${this.bitpayButtonId}`);
      if ($bitPayButton) {
        $bitPayButton.addEventListener('click', window.handleClickBitPayButton);
      }

      // Set up the listener when the modal opens, then redirect
      // We do this here and not on showPopUp because we don't want this behaviour
      // in order module, just open the pop up (it's more atomic).

      if (window.bitpay) {
        window.bitpay.onModalWillEnter(() => {
          dispatch(asyncPaymentRedirectToOrderPage(order));
        });
        window.bitpay.onModalWillLeave(() => {
          // console.log("onModalWillLeave")
        });
      }
    }
  };

  generateCustomUI(): Node {
    return (
      <section id={this.uiId} style={{ textAlign: 'center', height: '100px', marginTop: '32px', minHeight: 85 }}>
        <input id="bitPayButton"
               type="image"
               src="https://test.bitpay.com/cdn/en_US/bp-btn-pay-currencies.svg"
               name="submit"
               style={{ margin: 'auto' }}
               alt="BitPay, the easy way to pay with bitcoins."/>
      </section>
    );
  };

  executeUIAction = (billingAddress: BillingAddressReq, rootState: RootState) => {
    const order = rootState.newOrder.checkoutStep.order;

    if (order.invoice.payment.method === 'MANUAL_SETTLEMENT' && order.invoice.detail.total === '0.00') {
      const paymentRequest: PaymentExecuteReq = {
        method: this.order.invoice.payment.method,
        type: this.order.invoice.payment.subtype,
        billingAddress: billingAddress,
      }
      
      postPaymentExecuteApi(paymentRequest, {
        route: endpoints.POST_PAYMENT_EXECUTE.replace(':paymentId', this.order.invoice.payment.id),
      }).toPromise().then(
        (order: Order) => {
          if (['AVAILABLE', 'AVAILABLE_FOR_COURIER'].includes(order.state)) {
            window.location.reload();
          }
        },
      ).catch(
        ({data}: {data: {message: string, name: string}}) => {
          console.log('Unsuccessful payment execution for Bitpay!', error);
          if (data.name === 'InvalidStateError') {
            document.location.reload();
          }
        },
      )
    }
  };

  showPopUp(data: string) {
    if (window.bitpay) {
      if (environment.env !== 'production') {
        window.bitpay.enableTestMode();
      }
      window.bitpay.showInvoice(data);
    } else {
      console.error('window.bitpay is not defined or wrong paymentData method');
    }
  }

  clean = () => {
    const $bitPayButton = document.querySelector(`#${this.bitpayButtonId}`);
    const $element = document.getElementById(this.uiId);

    if ($bitPayButton) {
      $bitPayButton.removeEventListener('click', window.handleClickBitPayButton);
    }

    if (!!window) {
      delete window.handleClickBitPayButton;
    }

    if ($element) {
      const $parent = $element.parentNode;
      if ($parent) {
        try {
          // $parent.removeChild($element);
        } catch (e) {
          console.log('clean e', e);
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/Bitpay/index.js